// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Input_inputWrapper__HT+sU","input":"Input_input__jdQ-a","bigger":"Input_bigger__HvGAB"};